import { Component, OnInit } from '@angular/core';
import { SessionService } from '@core/services/Session';
import { Router } from '@angular/router';

@Component({
  selector: 'sf-access-denied',
  templateUrl: './access-denied.page.html',
  styleUrls: ['./access-denied.page.scss']
})

export class AccessDeniedPageComponent {
  constructor(private session: SessionService, private route: Router) { }

  goBack() {
    this.session.logout();
    this.route.navigate(['']);
  }
}
